<template>
  <div name="test1">
    <div v-show="detailDisp">
      <input type="button" @click="detailDisp = !detailDisp" value="close" />
      {{detail}}
    </div>
    <div v-show="descCodapprDisp">
      <input type="button" @click="descCodapprDisp = !descCodapprDisp" value="close" />
      {{descCodappr}}
    </div>
    <div v-show="descCodempapDisp">
      <input type="button" @click="descCodempapDisp = !descCodempapDisp" value="close" />
      {{descCodempap}}
    </div>
    <div v-for="(val, key) in selected">
      {{ key }} : {{ val }}
    </div>
    <hrms-table :columns="columns"
                :data="data"
                :page="1"
                :limit="10"
                :indexDisp="indexDisp"
                :multiSelect="multiSelect"
                v-model="selected"
                :maxRowspan="maxRowspan"
                :columnEvent="columnEvent"
                :staapprDisp="staapprDisp"
                :detailDisp="true"
                :detailEvent="detailEvent" />
  </div>
</template>

<script>
import { mockColumns, mockMaxRowspan, mockTotal, mockRows } from './mockData'

export default {
  name: 'test1',
  data () {
    return {
      columns: mockColumns,
      maxRowspan: mockMaxRowspan,
      data: {
        total: mockTotal,
        rows: mockRows
      },
      selected: {},
      indexDisp: true,
      multiSelect: false,
      descCodapprDisp: false,
      descCodappr: '',
      descCodempapDisp: false,
      descCodempap: '',
      detailDisp: false,
      detail: {},
      staapprDisp: true
    }
  },
  methods: {
    toggleDescCodappr (descCodappr) {
      this.descCodapprDisp = !this.descCodapprDisp
      this.descCodappr = descCodappr
    },
    toggleDescCodempap (descCodempap) {
      this.descCodempapDisp = !this.descCodempapDisp
      this.descCodempap = descCodempap
    },
    toggleDetail (detail) {
      this.detailDisp = !this.detailDisp
      this.detail = detail
    },
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'codappr':
          this.toggleDescCodappr(param)
          break
        case 'codempap':
          this.toggleDescCodempap(param)
          break
      }
    },
    detailEvent (param) {
      this.toggleDetail(param)
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?4b1f66a3